<template>
    <v-list two-line style="max-height: 238px; min-height: 238px;" class="overflow-y-auto">
        <v-list-item-group v-model="selectedResources" multiple active-class="pink--text">
            <div class="text-center" style="margin-bottom: 7px;"><v-btn small color="primary" dark @click="on_selectAll">Select all</v-btn></div>

            <template v-for="(item, index) in get_selectedMultiResources">
                <v-list-item :key="item.originalId" :value="item.id">
                    <template v-slot:default="{ active, toggle }">
                        <v-list-item-icon>
                            <v-icon>mdi-account-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                <strong>{{ item.lastName.trim() }}, {{ item.firstName.trim() }}</strong>
                            </v-list-item-title>
                            <v-list-item-subtitle class="text--primary">{{ item.contract3Code }} - {{ item.contractFunction }} {{ item.contractAddFunction }}, Phone: {{ item.comPhone1 }}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text>(id:{{ item.id }})</v-list-item-action-text>
                        </v-list-item-action>
                    </template>
                </v-list-item>

                <v-divider v-if="index + 1 < get_selectedMultiResources.length" :key="index"></v-divider>
            </template>

        </v-list-item-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {
        name : 'selectedemployeeslist',

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note: 'Select all' @startup.
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/SelectedEmployeesList.vue >>> mounted');
            this.on_selectAll();

        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                selectedResources: [], // selected Resources
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            selectedResources(value) {

                this.$emit('input', value);

            }, // eo selectedResources()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_Resources',
                'get_selectedMultiResources'
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * on_selectAll()
            *
            * Desc: Select all Resources.
            * Note:
            *
            */
            on_selectAll: function(){

                let me = this,
                    allResources = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/SelectedEmployeesList.vue >>> on_selectAll');
                this.get_selectedMultiResources.forEach((item, i) => {
                    allResources.push(item.data.id);
                });
                this.selectedResources = [...allResources]

            }, // eo function on_selectAll()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* .v-card .v-divider {
        border-color: #d2d2d2;
    } */
    .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
        margin-bottom: 0px;
    }




    .v-list--two-line .v-list-item .v-list-item__icon, .v-list-item--two-line .v-list-item__icon {
        margin-bottom: 12px;
    }

    .v-list--two-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal), .v-list--two-line .v-list-item .v-list-item__icon, .v-list--three-line .v-list-item .v-list-item__avatar:not(.v-list-item__avatar--horizontal), .v-list--three-line .v-list-item .v-list-item__icon, .v-list-item--two-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal), .v-list-item--two-line .v-list-item__icon, .v-list-item--three-line .v-list-item__avatar:not(.v-list-item__avatar--horizontal), .v-list-item--three-line .v-list-item__icon {
        margin-bottom: 16px;
        margin-top: 24px;
    }

    .v-list-item {
        padding: 0 26px;
    }
</style>